import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { colors } from "../theme";
export function Badge({ badgeContent, disabledCart, children }) {
    return (_jsxs(Container, { children: [children, _jsx(Content, Object.assign({ disabledCart: disabledCart }, { children: badgeContent }), void 0)] }, void 0));
}
const Container = styled.span(() => ({
    display: "inline-flex",
    position: "relative",
    verticalAlign: "middle",
}));
const Content = styled.span(({ disabledCart }) => ({
    alignContent: "center",
    alignItems: "center",
    backgroundColor: disabledCart ? colors.greyMain : colors.redMain,
    borderRadius: "2rem",
    color: colors.white,
    display: "flex",
    fontFamily: "OpenSans, sans-serif",
    fontSize: "1.2rem",
    height: "2rem",
    justifyContent: "center",
    minWidth: "2rem",
    padding: "0 0.6rem",
    position: "absolute",
    right: 0,
    top: 0,
    transform: "scale(1) translate(50%, -50%)",
    transformOrigin: "100% 0%",
    zIndex: 1,
}));
//# sourceMappingURL=Badge.js.map